import PropTypes from 'prop-types'

export default PropTypes.shape({
  subscribe: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  getState: PropTypes.func.isRequired
})



//////////////////
// WEBPACK FOOTER
// /home/circleci/project/node_modules/react-redux/src/utils/storeShape.js
// module id = 1631
// module chunks = 0